<template>
    <div style="width: 100%">
        <plt-page-title>客户维护</plt-page-title>
        <div style="display: flex">
            <plt-table ref="dg" url="CORE-MEMBER/messageService/memberCustomerService/queryCustomerByMemberId"
                :queryParams="{memberId, roleId: 'MEMBER_CUSTOMER'}" :pagination="false" style="width: 541px" >
                <template #title>
                    <span>客户列表</span>
                    <el-button type="success" size="mini" style="margin-left: 50px" @click="openAddCustomerDialog">添加客户</el-button>
                </template>
                <template #table="{data, pageSize, pageNum}"  >
                    <el-table :data="data" border size="mini" highlight-current-row @current-change="clickCustomerRow"  >
                        <el-table-column label="#" width="40" align="center" type="index" :index="(index) => index + pageSize * (pageNum - 1) + 1" />
                        <el-table-column prop="id" label="客户编号" width="150" />
                        <el-table-column prop="name" label="客户名称" width="250" />
                        <el-table-column prop="action" label="修改" width="100" >
                            <template #default="{ row }" >
                                <el-button type="primary" @click="openUpdateCustomerDialog(row)" size="mini">修改</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </plt-table>

            <plt-table ref="dg-cw" url="CORE-MEMBER/messageService/memberCustomerService/queryContactWaysByMemberId" 
                :queryParams="contactWayQueryParam" :pagination="false" :queryOnLoad="false"  >
                <template #title>
                    <span>联系方式</span>
                    <el-button type="success" size="mini" style="margin-left: 50px" @click="openAddContactWayDialog">添加联系人</el-button>
                </template>
                <template #table="{data, pageSize, pageNum}"  >
                    <el-table :data="data" border size="mini" >
                        <el-table-column label="#" width="40" align="center" type="index" :index="(index) => index + pageSize * (pageNum - 1) + 1" />
                        <el-table-column prop="name" label="联系人名称" width="200" />
                        <el-table-column prop="mobile" label="手机号" width="150" />
                        <plt-table-dict-col prop="areaId" label="省市区" width="200" namespace="region" id="fullArea" />
                        <el-table-column prop="address" label="详细地址" width="150" />
                        <el-table-column prop="action" label="修改" width="100" >
                            <template #default="{ row }" >
                                <el-dropdown>
                                    <el-button type="primary" size="mini">
                                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item style="color: #2b85e4;" @click.native="openUpdateContactWayDialog(row)">修改</el-dropdown-item>
                                        <!-- <el-dropdown-item style="color: #ed3f14;" @click.native="deleteContactWay(row)" >删除</el-dropdown-item> -->
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </plt-table>
        </div>
        
        <el-dialog :title="dl_title" :visible.sync="cus_dl_vis">
            <span>客户名称：</span>
            <el-input v-model="customerName" placeholder="请输入客户名称" style="width: 300px"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cus_dl_vis = false">取 消</el-button>
                <el-button type="primary" @click="dialogAction">确 定</el-button>
            </div>            
        </el-dialog>
        <edit-contact-way-dialog ref="cw-dl" @on-edit-success="$refs['dg-cw'].queryData()" />
    </div>
</template>

<script>

import editContactWayDialog from './edit-contact-way-dialog';
export default {
    components: {editContactWayDialog},
    data() {
        return {
            memberId: '',
            cus_dl_vis: false,
            customerName: '',
            customerId: '',
            dl_title: '',

            contactWayQueryParam: {
                memberId: ''
            }
        }
    },
    created() {
        this.memberId = sessionStorage.getItem("memberId");
    },
    methods: {
        openAddCustomerDialog() {
            this.dl_title = '添加客户';
            this.customerName = '';
            this.cus_dl_vis = true;
        },
        dialogAction() {
            if(this.dl_title == '添加客户') {
                this.addCustomerAction();
            }
            if(this.dl_title == '修改客户') {
                this.updateCustomer();   
            }
        },
        addCustomerAction() {

            let url = "CORE-MEMBER/messageService/memberCustomerService/addCustomerByMemberId";

            let param = {
                customerName: this.customerName,
                memberId: this.memberId,
                roleId: "MEMBER_CUSTOMER"
            }

            this.invoke(url, param, true).then(() => {
                this.cus_dl_vis = false;
                this.$refs['dg'].queryData();
            })

        },
        openUpdateCustomerDialog(row) {
            this.dl_title = '修改客户';
            this.customerId = row.id;
            this.customerName = row.name;
            this.cus_dl_vis = true;
        },
        updateCustomer() {
            let url = "CORE-MEMBER/messageService/memberCustomerService/updateCustomerName";
            let param = {
                customerName: this.customerName,
                customerId: this.customerId,
            }
            this.invoke(url, param).then(() => {
                this.cus_dl_vis = false;
                this.$refs['dg'].queryData();
            })
        },
        clickCustomerRow(row) {
            this.contactWayQueryParam.memberId = row.id;
            this.$refs['dg-cw'].queryData();
        },
        openAddContactWayDialog() {
            this.notBlank(this.contactWayQueryParam.memberId, '请选择一个客户');
            this.$refs['cw-dl'].openDialog(this.contactWayQueryParam);    
        },
        openUpdateContactWayDialog(row) {
            this.notBlank(row, '请选择一个联系人');
            this.$refs['cw-dl'].openDialog(row);
        },
        deleteContactWay(row) {
            this.notBlank(row, '请选择一个联系人');

            let url = "CORE-MEMBER/messageService/memberCustomerService/deleteContactWay";
            let param = {addressId: row.addressId};

            this.cfmInvoke(url, param, undefined, '确认删除?').then(() => this.$refs['dg-cw'].queryData());
        }
    } 
}
</script>